import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Provides admin-managed image overrides + editable section titles.
// When a slot has no override, components fall back to their existing default,
// so the site renders exactly as before.
const SiteContentContext = createContext({ images: {}, titles: {}, purchaseLinks: {}, purchasePrices: {} });

export const useSiteContent = () => useContext(SiteContentContext);

export const SiteContentProvider = ({ children }) => {
  const [data, setData] = useState({ images: {}, titles: {}, purchaseLinks: {}, purchasePrices: {} });

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/site-content`, { timeout: 12000 })
      .then((r) => {
        if (!active) return;
        const d = r.data || {};
        const images = {};
        Object.entries(d.images || {}).forEach(([k, v]) => {
          images[k] = typeof v === "string" && v.startsWith("http") ? v : `${BACKEND_URL}${v}`;
        });
        setData({ images, titles: d.titles || {}, purchaseLinks: d.purchaseLinks || {}, purchasePrices: d.purchasePrices || {} });
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, []);

  return (
    <SiteContentContext.Provider value={data}>{children}</SiteContentContext.Provider>
  );
};
